<template>
  <div
    class="form__field-holder"
    :class="{ 'form__field-holder_error': !!errors.has(newName) }"
    data-vv-value-path="model"
    :data-vv-as="label"
  >
    <div class="form__field-box">
      <label class="form__label" v-if="label">
        {{ label }}
      </label>

      <div :class="{ 'form__extra-info': IsExtraInfo }">
        <vue-numeric
          class="form__textfield"
          v-model="model"
          :minus="true"
          :name="name"
          :precision="precision"
          thousand-separator
          decimal-separator=","
          @change="$emit('change', $event)"
          @blur="$emit('blur', $event)"
        >
        </vue-numeric>
        <template v-show="IsExtraInfo">
          <div class="form__extra-info__content">
              <slot name="extra-info"></slot>
          </div>
        </template>
      </div>

      <div class="form__field-error" v-if="errors.has(newName)">
        {{ errors.first(newName) }}
      </div>
    </div>
  </div>
</template>

<script>
import field from "../mixins/field";
import VueNumeric from "vue-numeric";

export default {
  mixins: [field],
  components: {
    VueNumeric,
  },
  props: {
    precision: {
      default: () => 2,
      type: Number,
    },
    IsExtraInfo: {
      default: false,
      type: Boolean,
    },
  },
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/admin/components/VNumericFieldPublic.vue